import { render, staticRenderFns } from "./RomPaginator.vue?vue&type=template&id=3c4ffaf9&"
import script from "./RomPaginator.vue?vue&type=script&lang=js&"
export * from "./RomPaginator.vue?vue&type=script&lang=js&"
import style0 from "./RomPaginator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports